<template>
  <div class="container">
    <SimpleHeader />

    <!--切换数据查看状态-->
    <div class="data-type-tab-container">
      <div class="data-type-tab">
        <div
          v-for="(item, index) in tabList"
          :key="index"
          @click="changeDataType(index)"
          class="data-type-tab-item"
          :class="{ 'tab-active': activeTab == index }"
          :style="activeTab == index ? 'color:' + theme.PrimaryFontColor : ''"
        >
          {{ item }}
        </div>
      </div>
    </div>

    <!--数据展示区-->
    <div class="data-show-container">
      <!--数据时间选择-->
      <div class="date-type-container">
        <van-tabs
          v-model:active="activeDate"
          :title-active-color="theme.PrimaryFontColor"
          :color="theme.PrimaryFontColor"
          line-width="24px"
          line-height="3px"
          title-inactive-color="#222222"
          @change="onChangeDate"
        >
          <van-tab v-for="(item, index) in dateList" :key="index" :title="item" title-class="date-title-style">
          </van-tab>
        </van-tabs>
      </div>
    </div>

    <!--图表数据-->
    <div class="data-chart-container">
      <div class="chart">
        <div id="orderLineChart" style="width: 100%; height: 100%"></div>
      </div>
      <div class="chartTip">
        <div class="chartTip-item" v-if="chartTipList.length > 0">
          <CountTo
            :startVal="0"
            :endVal="chartTipList[0].num"
            :duration="2000"
            :decimals="String(chartTipList[0].num).indexOf('.') + 1 > 0 ? 2 : 0"
            style="font-size: 18px; font-weight: 500; color: #222222"
          ></CountTo>
          <div class="chartTip-text">
            <div class="chartTip-icon"></div>
            <div class="chartTip-desc">{{ chartTipList[0].name }}</div>
          </div>
        </div>
        <div class="chartTip-item" v-if="chartTipList.length > 0">
          <CountTo
            :startVal="0"
            :endVal="chartTipList[1].num"
            :duration="2000"
            :decimals="String(chartTipList[1].num).indexOf('.') + 1 > 0 ? 2 : 0"
            style="font-size: 18px; font-weight: 500; color: #222222"
          ></CountTo>
          <div class="chartTip-text">
            <div class="chartTip-icon1"></div>
            <div class="chartTip-desc">{{ chartTipList[1].name }}</div>
          </div>
        </div>
        <div class="chartTip-item" v-if="chartTipList.length > 2">
          <CountTo
            :startVal="0"
            :endVal="chartTipList[2].num"
            :duration="2000"
            :decimals="String(chartTipList[2].num).indexOf('.') + 1 > 0 ? 2 : 0"
            style="font-size: 18px; font-weight: 500; color: #222222"
          ></CountTo>
          <div class="chartTip-text">
            <div class="chartTip-icon2"></div>
            <div class="chartTip-desc">{{ chartTipList[2].name }}</div>
          </div>
        </div>
      </div>
    </div>

    <!--表格数据-->
    <div class="list-chart-container">
      <div class="list-line"></div>
      <div class="list-title-container">
        <div class="list-title" v-if="activeTab == 0">
          近{{ activeDate == 0 ? 7 : activeDate == 1 ? 30 : 60 }}天页面访问排行榜
        </div>
        <div class="list-title" v-if="activeTab == 1">
          近{{ activeDate == 0 ? 7 : activeDate == 1 ? 30 : 60 }}天订单商品排行榜
        </div>
        <div class="list-title" v-if="activeTab > 1">
          近{{ activeDate == 0 ? 7 : activeDate == 1 ? 30 : 60 }}天店铺{{
            activeTab == 2 ? '营收' : activeTab == 3 ? '进货' : '利润'
          }}数据
        </div>
        <div class="list-title-desc" v-if="activeTab < 2">排行数据截止至昨日</div>
        <div class="list-title-desc" v-if="activeTab > 1">数据截止至昨日</div>
      </div>
      <div class="list-vant" v-if="activeTab < 2">
        <van-list v-model:loading="loadingList" :finished="finished" finished-text="没有更多了" @load="onListLoad">
          <div class="list-column-contianer">
            <div class="list-column" v-for="(item, index) in listCoulmn[activeTab]" :key="index">{{ item }}</div>
          </div>
          <div class="list-column-item" v-for="(item, index) in rankingList" :key="index">
            <div class="list-column-cell">{{ index + 1 }}</div>
            <div class="list-column-cell !block" v-if="activeTab == 0">{{ item.viewName }}</div>
            <div class="list-column-cell" v-if="activeTab == 0">{{ item.accessNum }}</div>
            <div class="list-column-cell" v-if="activeTab == 0">{{ item.browseNum }}</div>
            <div class="list-column-cell !block" v-if="activeTab == 1">{{ item.goodsName }}</div>
            <div class="list-column-cell" v-if="activeTab == 1">{{ item.goodsSaleNum }}</div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>
<script>
import SimpleHeader from '@/components/SimpleHeader'
import * as echarts from 'echarts'
import { CountTo } from 'vue3-count-to'
import { onMounted, nextTick, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { showToast, PullRefresh, Tab, Tabs, List } from 'vant'
import usePage from '@/hooks/usePage'
import { getReportAgentData, getReportTableListData } from '@/api/data'
import { getLocal } from '@/common/js/utils'
import { useUserStore } from '@/store/user'
export default {
  name: 'home',
  components: {
    CountTo,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    SimpleHeader
  },
  setup() {
    const userStore = useUserStore()
    const theme = computed(() => userStore.getTheme)
    const info = ref({})
    const tabList = ref(['访客', '订单', '营收', '进货', '利润'])
    const dateList = ref(['近7天', '近30天', '近60天'])
    const activeTab = ref(0)
    const activeDate = ref(0)
    const router = useRouter()
    const { navigateTo } = usePage()
    // 下拉刷新页面
    const refreshing = ref(false)
    const list = ref([])
    //列表参数
    const loadingList = ref(false)
    const finished = ref(false)
    const lcData = ref([]) //图表X轴数据
    const lcXAxisData = ref([]) //图表Y轴数据
    const chartTipList = ref([]) //图表图例数据
    const rankingList = ref([]) //排行榜数据
    const rankingPageSize = ref(10) //排行榜查询条数
    const rankingPage = ref(1) //排行榜当前页
    const rankingTotal = ref(0) //排行榜总数量
    const listCoulmn = ref([
      ['序号', '页面', '访客人数', '浏览次数'],
      ['序号', '商品', '销量']
    ])

    const onListLoad = () => {
      setTimeout(() => {
        let rl = rankingList.value
        console.log(rl.length)
        console.log(rankingTotal.value)
        rankingPage.value = rankingPage.value + 1
        getTableData()
        // 加载状态结束
        loadingList.value = false
        // 数据全部加载完成
        if (rl.length == rankingTotal.value) {
          finished.value = true
        }
      }, 1000)
    }

    //切换数据来源tab
    function changeDataType(index) {
      activeTab.value = index
      lcData.value = [] //图表X轴数据
      lcXAxisData.value = [] //图表X轴数据
      chartTipList.value = [] //图表X轴数据
      activeDate.value = 0
      rankingTotal.value = 0
      rankingPage.value = 1
      rankingList.value = []
      getChartData()
      if (index == 0 || index == 1) {
        getTableData()
      }
    }
    function onChangeDate() {
      lcData.value = [] //图表X轴数据
      lcXAxisData.value = [] //图表X轴数据
      chartTipList.value = [] //图表X轴数据
      rankingTotal.value = 0
      rankingPage.value = 1
      rankingList.value = []
      getChartData()
      getTableData()
    }
    //获取折线图数据
    async function getChartData() {
      let userSelectType = activeTab.value //用户选择查看数据的类型 0，访客1，订单2，营收，3进货，4利润
      let userSelectDate = activeDate.value //0.近7天 1.近30天 2.近60天
      let dateUnitType = '' //时间类型
      let timeList = []
      if (userSelectDate == 0) {
        timeList = getBeforeDateStr(7)
        dateUnitType = '日'
      } else if (userSelectDate == 1) {
        timeList = getBeforeDateStr(30)
        dateUnitType = '周'
      } else {
        timeList = getBeforeDateStr(60)
        dateUnitType = '周'
      }
      let param = {
        dataType: userSelectType + 1, //数据类型
        startDate: timeList[1],
        endDate: timeList[0],
        dateUnit: dateUnitType
      }
      let res = await getReportAgentData(param)
      getOrderCreatePieDataInfo(res, userSelectType)
    }

    //获取排行榜数据
    async function getTableData() {
      let userSelectType = activeTab.value //用户选择查看数据的类型 0，访客1，订单2，营收，3进货，4利润
      let userSelectDate = activeDate.value //0.近7天 1.近30天 2.近60天
      let timeList = []
      if (userSelectDate == 0) {
        timeList = getBeforeDateStr(7)
      } else if (userSelectDate == 1) {
        timeList = getBeforeDateStr(30)
      } else {
        timeList = getBeforeDateStr(60)
      }
      let param = {
        dataType: userSelectType + 1, //数据类型
        startDate: timeList[1],
        endDate: timeList[0],
        page: rankingPage.value,
        pageSize: rankingPageSize.value
      }
      let res = await getReportTableListData(param)
      let oldList = rankingList.value
      if (oldList.length == 0) {
        rankingList.value = res.list
      } else {
        for (let i = 0; i < res.list.length; i++) {
          oldList.push(res.list[i])
        }
        rankingList.value = oldList
      }
      rankingTotal.value = res.total
    }

    //获取过去的时间
    function getBeforeDateStr(dayNumber) {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let nowDate = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
      //获取30天前得日期
      let lastDate = new Date(date - 1000 * 60 * 60 * 24 * dayNumber) //最后30天可以更改，意义：是获取多少天前的时间
      let lastY = lastDate.getFullYear()
      let lastM = lastDate.getMonth() + 1
      let lastD = lastDate.getDate()
      let LDate = lastY + '-' + (lastM < 10 ? '0' + lastM : lastM) + '-' + (lastD < 10 ? '0' + lastD : lastD) //得到30天前的时间
      return [nowDate, LDate]
    }

    //处理折线图数据
    async function getOrderCreatePieDataInfo(param, type) {
      let returnLet = param
      let xList = []
      let yListCreateCount = []
      let yListPayCount = []
      let yListSuccessCount = []
      let tip = []

      if (type == 0) {
        if (returnLet.data.length > 0) {
          for (let i = 0; i < returnLet.data.length; i++) {
            xList.push(returnLet.data[i].name)
            yListCreateCount.push(returnLet.data[i].accessNum) //访客数量
            yListPayCount.push(returnLet.data[i].browseNum) //浏览次数
          }
        }
        tip = [
          {
            name: '访客数量',
            num: returnLet.statistics.accessNum
          },
          {
            name: '浏览次数',
            num: returnLet.statistics.browseNum
          }
        ]
      } else if (type == 1) {
        if (returnLet.data.length > 0) {
          for (let i = 0; i < returnLet.data.length; i++) {
            xList.push(returnLet.data[i].name)
            yListCreateCount.push(returnLet.data[i].orderNum) //支付单数
            yListPayCount.push(returnLet.data[i].afterPreparingCancelNum) //备货前取消
            yListSuccessCount.push(returnLet.data[i].afterSaleNum) //售后单数
          }
        }
        tip = [
          {
            name: '支付单数',
            num: returnLet.statistics.orderNum
          },
          {
            name: '备货前取消',
            num: returnLet.statistics.afterPreparingCancelNum
          },
          {
            name: '售后单数',
            num: returnLet.statistics.afterSaleNum
          }
        ]
      } else if (type == 2) {
        if (returnLet.data.length > 0) {
          for (let i = 0; i < returnLet.data.length; i++) {
            xList.push(returnLet.data[i].name)
            yListCreateCount.push(returnLet.data[i].selfSalesAmount) //自营销售额(元)
            yListPayCount.push(returnLet.data[i].teamsSalesAmount) //团队销售额(元)
          }
        }
        tip = [
          {
            name: '自营销售额(元)',
            num: returnLet.statistics.selfSalesAmount
          },
          {
            name: '团队销售额(元)',
            num: returnLet.statistics.teamsSalesAmount
          }
        ]
      } else if (type == 3) {
        if (returnLet.data.length > 0) {
          for (let i = 0; i < returnLet.data.length; i++) {
            xList.push(returnLet.data[i].name)
            yListCreateCount.push(returnLet.data[i].selfIncomeAmount) //自营进货额(元)
            yListPayCount.push(returnLet.data[i].teamsIncomeAmount) //团队进货额(元)
          }
        }
        tip = [
          {
            name: '自营进货额(元)',
            num: returnLet.statistics.selfIncomeAmount
          },
          {
            name: '团队进货额(元)',
            num: returnLet.statistics.teamsIncomeAmount
          }
        ]
      } else {
        if (returnLet.data.length > 0) {
          for (let i = 0; i < returnLet.data.length; i++) {
            xList.push(returnLet.data[i].name)
            yListCreateCount.push(returnLet.data[i].selfProfitAmount) //自营利润额(元)
            yListPayCount.push(returnLet.data[i].teamsProfitAmount) //团队利润额(元)
          }
        }
        tip = [
          {
            name: '自营利润额(元)',
            num: returnLet.statistics.selfProfitAmount
          },
          {
            name: '团队利润额(元)',
            num: returnLet.statistics.teamsProfitAmount
          }
        ]
      }
      //组装数据
      if (type == 1) {
        lcData.value = [
          {
            name: tip[0].name,
            data: yListCreateCount,
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: [6, 6],
            itemStyle: {
              normal: {
                color: '#58D8A6',
                lineStyle: {
                  color: '#58D8A6'
                }
              }
            }
          },
          {
            name: tip[1].name,
            data: yListPayCount,
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: [6, 6],
            itemStyle: {
              normal: {
                color: '#E8694A',
                lineStyle: {
                  color: '#E8694A'
                }
              }
            }
          },
          {
            name: tip[2].name,
            data: yListSuccessCount,
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: [6, 6],
            itemStyle: {
              normal: {
                color: '#9270CA',
                lineStyle: {
                  color: '#9270CA'
                }
              }
            }
          }
        ]
      } else {
        lcData.value = [
          {
            name: tip[0].name,
            data: yListCreateCount,
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: [6, 6],
            itemStyle: {
              normal: {
                color: '#58D8A6',
                lineStyle: {
                  color: '#58D8A6'
                }
              }
            }
          },
          {
            name: tip[1].name,
            data: yListPayCount,
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: [6, 6],
            itemStyle: {
              normal: {
                color: '#E8694A',
                lineStyle: {
                  color: '#E8694A'
                }
              }
            }
          }
        ]
      }

      lcXAxisData.value = xList
      chartTipList.value = tip
      createPie()
    }

    //渲染折线图
    function createPie() {
      //饼图 项目数量
      document.getElementById('orderLineChart').setAttribute('_echarts_instance_', '')
      let chartDom = document.getElementById('orderLineChart')
      let myChart = echarts.init(chartDom)
      let option = {
        tooltip: {
          trigger: 'axis'
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        grid: {
          top: '30px',
          left: '50px',
          right: '20px',
          bottom: '30px'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: lcXAxisData.value
        },
        series: lcData.value
      }
      option && myChart.setOption(option)
      let sizeFun = function () {
        myChart.resize()
      }
      window.addEventListener('resize', sizeFun)
    }
    onMounted(async () => {
      getChartData()
      getTableData()
    })

    return {
      refreshing,
      list,
      info,
      tabList,
      changeDataType,
      activeTab,
      activeDate,
      dateList,
      loadingList,
      finished,
      onListLoad,
      listCoulmn,
      onChangeDate,
      chartTipList,
      rankingList,
      theme
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  background-color: #ffffff;
}
.router-view {
  width: 100%;
  position: initial;
  height: auto;
  margin: 0 auto;
  -webkit-overflow-scrolling: touch;
}
.data-type-tab-container {
  width: 100%;
  padding-top: 7px;
  padding-left: 27px;
  padding-right: 27px;
  box-sizing: border-box;
  margin-bottom: 7px;
}
.data-type-tab {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #f5f6f7;
  padding: 3px;
  box-sizing: border-box;
}
.data-type-tab-item {
  flex: 1;
  height: 30px;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  font-weight: normal;
  color: #222222;
}
.tab-active {
  background: #ffffff;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  font-weight: bold;
}
.data-show-container {
  width: 100%;
  border-top: 1px solid #f6f7f7;
}
.date-type-container {
  margin-top: 10px;
  padding-left: 60px;
  padding-right: 60px;
  box-sizing: border-box;
}
.date-title-style {
  font-size: 14px;
  font-weight: 400;
  color: #222222;
}
.data-chart-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.chart {
  width: 100%;
  height: 200px;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
}
.chartTip {
  width: 100%;
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
}
.chartTip-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.chartTip-text {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.chartTip-icon {
  width: 6px;
  height: 6px;
  background: #5ad8a6;
  border-radius: 50%;
}
.chartTip-icon1 {
  width: 6px;
  height: 6px;
  background: #e8684a;
  border-radius: 50%;
}
.chartTip-icon2 {
  width: 6px;
  height: 6px;
  background: #9270ca;
  border-radius: 50%;
}
.chartTip-desc {
  font-size: 12px;
  font-weight: 400;
  color: #8c8c8c;
  margin-left: 5px;
}
.list-chart-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
}
.list-title-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}
.list-title {
  font-size: 14px;
  font-weight: 500;
  color: #222222;
}
.list-title-desc {
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  margin-left: auto;
}
.list-line {
  width: 100%;
  height: 10px;
  background-color: #f5f6f7;
}
.list-vant {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  box-sizing: border-box;
}
.list-column-contianer {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #f5f6f7;
  padding-top: 5px;
  padding-bottom: 5px;
}
.list-column {
  flex: 1;
  font-size: 12px;
  font-weight: 500;
  color: #999999;
  text-align: center;
}
.list-column-item {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
}
.list-column-cell {
  flex: 1;
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  color: #222222;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
